/* eslint-disable no-shadow */
import api from '@api/index';

const state = {
  userDevices: {},
  selectedDevice: {},
  cmdBlockStatus: '',
};

const getters = {
  getUserDevices(state) {
    return state.userDevices;
  },
  getSelectedDevice(state) {
    return state.selectedDevice;
  },
  cmdBlockStatus(state) {
    return state.cmdBlockStatus;
  },
};

const mutations = {
  SET_USER_DEVICES(state, payload) {
    state.userDevices = payload;
  },
  SET_SELECTED_DEVICE(state, payload) {
    state.selectedDevice = payload;
  },
  SET_CMD_BLOCK_STATUS(state, payload) {
    state.cmdBlockStatus = payload;
  },
};

const actions = {
  async FETCH_USER_DEVICES({ commit }) {
    const response = await api.deviceInfo.getUserDevices();
    commit('SET_USER_DEVICES', response.data.items);
    return response;
  },

  async FETCH_DEVICE_CMD_BLOCK_STATUS({ commit }, userId) {
    const response = await api.deviceInfo.checkCmdBlockStatus(userId);
    commit('SET_CMD_BLOCK_STATUS', response.data.items.cmd_block_status);
    return response;
  },

  async FETCH_DEVICE_VENDER(_, obj) {
    const response = await api.deviceInfo.fetchedDeviceVender(obj.id);
    return response.data.items;
  },

  EDIT_GROUP_NAME(_, reqInfo) {
    return api.deviceInfo.editGroupName(reqInfo);
  },

  SAVE_SELECTED_DEVICE({ commit }, selectedDevice) {
    commit('SET_SELECTED_DEVICE', selectedDevice);
  },
};

export default {
  state,
  getters,
  mutations,
  actions,
};
